import React, { useState, } from 'react';
import { Button, } from 'reactstrap';
import classnames from 'classnames';

import ImportMappingModal from './modals/ImportMappingModal';
import ImportHistoryButton from './ImportHistoryButton';

export default function ImportMappingButton({
  label = 'インポート',
  fields,
  onImport,
  encoding = 'Shift_JIS',
  storageKey,
  importKey,
  disabled = false,
  beforeDeleteImport = _ => true,
  deleteImportConfirmMessage,
  deleteImportDisabled = _ => false,
  ...extraProps
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(x => !x);

  return (
    <div className="d-flex align-items-end gap-1">
      <Button color="secondary" outline onClick={toggle} disabled={disabled} {...extraProps}>
        <span className={classnames('fas fa-upload', { 'mr-1': !!label })} />
        {label}
        {importKey && <ImportHistoryButton importKey={importKey} beforeDeleteImport={beforeDeleteImport} deleteImportConfirmMessage={deleteImportConfirmMessage} deleteImportDisabled={deleteImportDisabled} />}
      </Button>
      <ImportMappingModal
        isOpen={isOpen}
        toggle={toggle}
        fields={fields}
        onImport={onImport}
        encoding={encoding}
        storageKey={storageKey}
        importKey={importKey}
      />
    </div>
  );
}
